import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Aside from './components/Aside';
import Navbar from './components/Navbar';
import Assets from './pages/Assets/Assets';
import Booking from './pages/Booking/Booking';
import Selling from './pages/Seelling/Selling';
import Service from './pages/Service/Service';
import Calendar from './pages/Calendar/Calendar';

function App(props) {
  return (
    <div>
      {/* <Aside/> */}
      <Aside />
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/assets' element={<Assets/>}/>
        <Route path='/booking' element={<Booking/>}/>
        <Route path='/sellCars' element={<Selling/>}/>
        <Route path='/services' element={<Service/>}/>
        <Route path='/calendar' element={<Calendar/>}/>
      </Routes>

    </div>
  );
}

export default App;